import { useState, useEffect, useCallback } from "react";
import { getUserKpiReport } from "../service/ReportingService";
import { showErrorMessage } from "../components/shared/pagination/messages";

const useUserKpiReport = () => {
  const [data, setData] = useState([]);

  const fetchUserKpiReport = useCallback(async (currentPage, pageSize, status , searchText) => {
    try {
      const response = await getUserKpiReport(currentPage - 1, pageSize, status, searchText);
      if (response.status ==="SUCCESS") {
        const records = response.data?.content || [];
        setData(records); 
        return response; 
      } else {
        const errMsg = response?.message || "Something went wrong.";
        showErrorMessage(errMsg);
      }
    } catch (error) {
      showErrorMessage(error?.message || "Something went wrong.");
    }
  }, []);

  return { data, fetchUserKpiReport };
};

export default useUserKpiReport;